<!-- バックヤード > メールテンプレート追加 -->
<template>
  <div>
    <v-row>
      <v-col>
        <div class="float-right">
          <v-btn @click="templateMailCancel">
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            @click="templateMailSave"
          >
            保存
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <Form />

    <v-row>
      <v-col>
        <div class="float-right">
          <v-btn @click="templateMailCancel">
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            @click="templateMailSave"
          >
            保存
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Utils from "../../../mixins/Utils";
  import Form from "./_Form";

  export default {
    components: {
      Form,
    },
    mixins: [
      Utils,
    ],
    data () {
      return {
      }
    },
    methods: {
      templateMailCancel: function () {
        this.$router.push({name: 'byTemplateMailIndex'})
      },
      templateMailSave: function () {
        this.$router.push({name: 'byTemplateMailIndex'})
      },
    },
  }
</script>

<style lang="scss">

</style>
